import React from 'react'

import { TermsModalTriggerLink } from './TermsModalTriggerLink'
import { TermsLinkComponent } from '../types'

export const TermsOfUseLink: TermsLinkComponent = ({
  className,
  setCurrentlyOpenTermsModal,
  text,
}) => (
  <TermsModalTriggerLink
    className={className}
    modalType="termsOfUse"
    setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
  >
    {text}
  </TermsModalTriggerLink>
)

TermsOfUseLink.defaultProps = {
  className: '',
  text: 'Terms of Use',
}
